import * as styleguide from "@store/Themes/common/styleguide";

export default styleguide;
